import {PATHS} from "../../../Utils/PagePaths";

export const edBriefDocs = [
    {
      title: "About PSOPPC & Help Center",
      cards: [ 2803, 2411, 1943, 143, ]
    },
    {
      title: "Data Submission",
      cards: [2471, 1288, 1188, 764, 744, 552, 144, 142, 140, 139, 137, 135, ]
    },
    {
      title: "AHRQ Common Formats",
      cards: [2763, 2372, 2371, 2328, 2244, 1871, 1842, 1762, 1588, 1642, 1087, 884, 361, 141,
        138, 134, ]
    },
    {
      title: "Account Setup",
      cards: [2287, 145, 136, ]
    },
    {
      title: "PSO Profile",
      cards: [2062, 381, ]
    },
];

export const helpTopics = {
  psoppc: [
    {
      title: "About PSOPPC",
      body: ["What are the main roles of the PSOPPC?", "Why does a PSO need to work with the PSOPPC?", "What is the Network of Patient Safety Databases (NPSD)?"],
      actions: {
        visitHref: PATHS.public['About PSOPPC'],
        emailHref: "support@psoppc.org",
        callHref: "+18665717712"
      }
    },
    {
      title: "Password Reset",
      body: [
        "How do I reset my password?",
        "How do I change my password, even if not expired?",
        "What happens if my account gets locked out?"
      ],
      isButton: true,
      groupId: "136"
    },
    {
      title: "Submit your PSO Profile",
      body: [
        "What are the key benefits of becoming a Federally-listed PSO?",
        "Why is submitting my PSO Profile important?",
        "What are the high-level steps to complete the PSO listing and profile submission process?"
      ],
      actions: {
        visitHref: PATHS.public['Become a PSO'],
        emailHref: "support@psoppc.org",
        callHref: "+18665717712"
      }
    },
    // {
    //   title: "Reports from Your Data",
    //   body: [
    //     "What types of reports can I generate from the PSOPPC?",
    //     "What is the difference between Clinical Dashboard Reports and the Comparative National Dashboard (CND)?",
    //     "How can I use the Patient Safety Data Submission Management Reports?",
    //     "Do I need an account to access the reports?"
    //   ],
    //   actions: {
    //     visitHref: PATHS.public['Sign In'],
    //     emailHref: "support@psoppc.org",
    //     callHref: "+18665717712"
    //   }
    // },
    {
      title: "PSOPPC Account Setup",
      body: ["How do I create a PSOPPC user account?", "What type of user accounts do I need?", "What information do I need to complete to create an account?", "What is the difference between Level 2 and Level 3 user accounts?", "What is the difference between a PSO account and a vendor account?"],
      actions: {
        visitHref: PATHS.public['User Account Types'],
        emailHref: "support@psoppc.org",
        callHref: "+18665717712"
      }
    },
    {
      title: "PSOPPC News & Website updates",
      body: ["What are the most recent PSOPPC website updates?", "Where can I find updated material or information on Quarterly Calls/Annual Meetings?", "What are the upcoming plans for the PSOPPC?"],
      actions: {
        visitHref: PATHS.public['Learn from the Data'],
        emailHref: "support@psoppc.org",
        callHref: "+18665717712"
      }
    },
    {
      title: "Technical Assistance with AHRQ Common Formats",
      body: ["Can I get technical assistance with using AHRQ Common Formats?", "What are the most current AHRQ Common Formats versions?", "Where can I find Common Formats documentation/samples?"],
      actions: {
        visitHref: PATHS.public['Use Common Formats'],
        emailHref: "support@psoppc.org",
        callHref: "+18665717712"
      }
    },
    {
      title: "Submitting Patient Safety Data",
      body: ["How do I submit Patient Safety Data to the PSOPPC?", "What format does my data have to be in?", "Where can I find samples and instructions?"],
      actions: {
        visitHref: PATHS.public['Submit Data'],
        emailHref: "support@psoppc.org",
        callHref: "+18665717712"
      }
    },
  ],
  ahrq: [
    {
      title: "General Information about the PSO Program",
      body: ["What is a PSO?", "What is the purpose of a PSO?", "What is the Provider to PSO relationship?"],
      actions: {
        visitHref: "https://pso.ahrq.gov/faq/what-is-a-pso",
        emailHref: "pso@ahrq.hhs.gov",
        callHref: "+18664033697"
      }
    },
    {
      title: "Content of AHRQ Common Formats",
      body: ["Why use AHRQ Common Formats?", "What is included in the AHRQ Common Formats?", "Where do I go to provide feedback for the AHRQ Common Formats?"],
      actions: {
        visitHref: "https://pso.ahrq.gov/common-formats/about",
        emailHref: "pso@ahrq.hhs.gov",
        callHref: "+18664033697"
      }
    },
    {
      title: "Information on Active PSOs",
      body: ["How can providers find my PSO?", "How does our PSO Profile work with the PSO Selection Tool?", "What is the PSO Selection Tool?", "My PSO's speciality is not listed on the Profile form, who do I contact to add it?"],
      actions: {
        visitHref: "https://pso.ahrq.gov/sites/default/files/wysiwyg/PSO-listing-guide-2022.pdf",
        emailHref: "pso@ahrq.hhs.gov",
        callHref: "+18664033697"
      }
    },
    {
      title: "Privacy & Confidentiality",
      body: ["Is my PSWP protected?", "Is data submitted to the NPSD protected?", "What is the HIPAA Privacy Rule?", "What is the Patient Safety Act and the Patient Safety Rule?"],
      actions: {
        visitHref: "https://pso.ahrq.gov/taxonomy/term/4",
        emailHref: "pso@ahrq.hhs.gov",
        callHref: "+18664033697"
      }
    },
    {
      title: "PSO Listing Process/Continued Listing",
      body: ["How can we become a PSO?", "What are the initial listing requirements? Are there any deadlines or expiration dates I should be aware of?", "How do I go about changing AO or POC Contact information?", "What are the dates for meeting the requirement for a PSO to have two Bona Fide Contacts?", "Who do I contact for online form submission problems?"],
      actions: {
        visitHref: "https://pso.ahrq.gov/become",
        emailHref: "pso@ahrq.hhs.gov",
        callHref: "+18664033697"
      }
    },
  ]
}
